import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

import { TDocumentDefinitions } from 'pdfmake/interfaces';
import { baseDefinitionStyles } from './baseDefinitionStyles';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export const createPdf = (
  content: TDocumentDefinitions['content'],
  definition?: Omit<TDocumentDefinitions, 'content'>,
) => {
  const documentDefinition: TDocumentDefinitions = {
    content,
    pageSize: 'A4',
    ...definition,
    info: {
      title: 'PDF документ',
      ...definition?.info,
    },
    styles: {
      ...baseDefinitionStyles,
      ...definition?.styles,
    },
  };

  return pdfMake.createPdf(documentDefinition);
};
